export default function Segments() {
  return (
    <div>
      <h2 className="text-lg font-semibold text-text_primary mb-1">Segments</h2>
      <p className="text-sm text-text_muted">Group contacts into targeted segments.</p>
    </div>
  );
}
